import React from 'react'

function CategoryDetailButton() {
    return (
        <>
            <span className='button--box'>
                <a href='#' id='CategoryViewButton' type='button' className="btn btn-sm btn btn-bg product-view-button"> View All Categories</a>
            </span>
        </>
    )
}

export default CategoryDetailButton;
